module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_022.png
// module id = 2338
// module chunks = 5